
export class MapUtils {

    public static buildMap (items : any, propertyId : string = 'id') {
        if (!items || items.length == 0) {
            return new Map();
        }

        const prepareMap = (property: any) => (item: any) => {
            if (item && item[property]) {
                return [item[property], item];
            }
        }

        return new Map( items.map(prepareMap(propertyId)).filter( (e :any) => e));
    }

}